import { useContext, useMemo } from 'react';

import { ConversationContext } from 'components/conversation';

export const useConversationLastMessage = (): string => {
  const { conversation } = useContext(ConversationContext);

  return useMemo(() => {
    const events = conversation?.events || [];
    const messages = events.filter(
      (event) =>
        event.type === 'conversation:message_added' &&
        event.direction === 'inbound',
    );
    return messages.length === 0
      ? ''
      : (messages[messages.length - 1].text as string) || '';
  }, [conversation]);
};
